// src/pages/BookingReort.jsx
import { useEffect, useState } from 'react'
import SideBar from '../commun/SideBar'
import Hearder from '../commun/Hearder'
import { PropertyBusinessSourceList, PropertyMarketSegmentApi, PropertyBookingReport, PropertyBookingReportPDF, getCorporatedetail, getagentlist } from '../../Services/Service';
import Select from "react-select";
export const BookingReort = () => {
    const [loading, setLoading] = useState(false);
    const [marketSegments, setMarketSegments] = useState([]);
    const [businessSources, setBusinessSources] = useState([]);
    const [bookingData, setBookingData] = useState([]);
    const [agentList, setAgentList] = useState([]);
    const [corporateList, setCorporateList] = useState([]);
    const [advanced, setAdvanced] = useState(false);
    // const [showMore, setShowMore] = useState(false);

    // controlled form state
    const [filters, setFilters] = useState({
        BookingDateFrom: '',
        BookingDateTo: '',
        CheckInDateFrom: '',
        CheckInDateTo: '',
        GuestName: '',
        AgentName: '',
        CompName: '',
        BusinessSource: [],
        MarketSegment: [],
        BookingStatus: '',
        PaymentStatus: '',
        ConfirmationNumber: '',
        BONRefNumber: ''
    });

    useEffect(() => {
        const fetchSegments = async () => {
            try {
                setLoading(true);
                const data = await PropertyMarketSegmentApi();
                if (data) setMarketSegments(data);
            } catch (err) {
                console.error("Error fetching market segments", err);
            } finally {
                setLoading(false);
            }
        };
        fetchSegments();
    }, []);

    useEffect(() => {
        const fetchBusinessSources = async () => {
            try {
                const data = await PropertyBusinessSourceList();
                if (data && Array.isArray(data)) setBusinessSources(data);
            } catch (error) {
                console.error("Error fetching business sources", error);
            }
        };
        fetchBusinessSources();
    }, []);

    useEffect(() => {
        const FetchAgentName = async () => {
            try {
                const result = await getagentlist();
                if (Array.isArray(result)) {
                    const filtered = result.filter(a => a.TA_Name && a.AgentID);
                    setAgentList(filtered);
                }
            } catch (error) {
                console.log("error get Agent Name", error);
            }
        };
        FetchAgentName();
    }, []);

    useEffect(() => {
        const FetchCorporateDetail = async () => {
            try {
                const result = await getCorporatedetail();
                if (Array.isArray(result)) {
                    const filtered = result.filter(
                        (corp) => corp.CorporateID && corp.TA_Name
                    );
                    setCorporateList(filtered);
                }
            } catch (error) {
                console.log("error get corporate detail", error);
            }
        };

        FetchCorporateDetail();
    }, []);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };

    const handleFilter = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            // call service - pass values (empty string for falsy)
            const res = await PropertyBookingReport(
                filters.BookingDateFrom || '',
                filters.BookingDateTo || '',
                filters.CheckInDateFrom || '',
                filters.CheckInDateTo || '',
                filters.GuestName || '',
                filters.AgentName || '',
                filters.CompName || '',
                filters.BusinessSource || '',
                filters.MarketSegment || '',
                filters.BookingStatus || '',
                filters.PaymentStatus || '',
                filters.ConfirmationNumber || '',
                filters.BONRefNumber || ''
            );

            // some APIs return object with .data, some return array — adapt safely
            const data = Array.isArray(res) ? res : (res && res.data) ? res.data : [];
            setBookingData(data);
        } catch (err) {
            console.error("Error fetching booking report", err);
            setBookingData([]);
        } finally {
            setLoading(false);
        }
    };

    const clearFilters = () => {
        setFilters({
            BookingDateFrom: '',
            BookingDateTo: '',
            CheckInDateFrom: '',
            CheckInDateTo: '',
            GuestName: '',
            AgentName: '',
            CompName: '',
            BusinessSource: '',
            MarketSegment: '',
            BookingStatus: '',
            PaymentStatus: '',
            ConfirmationNumber: '',
            BONRefNumber: ''
        });
        setBookingData([]);
    };


    const handleExport = async () => {
        try {
            setLoading(true);

            const res = await PropertyBookingReportPDF(
                filters.BookingDateFrom,
                filters.BookingDateTo,
                filters.CheckInDateFrom,
                filters.CheckInDateTo,
                filters.GuestName,
                filters.AgentName,
                filters.CompName,
                filters.BusinessSource,
                filters.MarketSegment,
                filters.BookingStatus,
                filters.PaymentStatus,
                filters.ConfirmationNumber,
                filters.BONRefNumber
            );

            const blob = new Blob([res.data], { type: "application/pdf" });

            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = `BookingReport_${Date.now()}.pdf`;
            link.click();

            window.URL.revokeObjectURL(link.href);
        } catch (error) {
            console.log("Export Error:", error);
        } finally {
            setLoading(false);
        }
    };



    return (
        <>

            <style>{`
        .advanced-wrap {
          max-height: 0;
          overflow: hidden;
          transition: max-height 350ms ease;
        }
        .advanced-wrap.open {
          /* adjust large value according to number of fields */
          max-height: 900px;
        }
        /* optional small fade effect */
        .advanced-inner {
          opacity: 0;
          transform: translateY(-6px);
          transition: opacity 250ms ease, transform 250ms ease;
        }
        .advanced-wrap.open .advanced-inner {
          opacity: 1;
          transform: translateY(0);
        }
      `}</style>

            <div className="wrapper">
                <SideBar />
                <div className="main-panel">
                    <Hearder />

                    <div className="container">
                        <div className="page-inner">

                            <div className='row'>
                                <div className='col-md-12'>

                                    {/* <form className='row' onSubmit={handleFilter}>
                                        
                                        <div className='col-md-2 mb-3'>
                                            <label className='form-label'>Booking From</label>
                                            <input name="BookingDateFrom" value={filters.BookingDateFrom} onChange={handleChange} type='date' className='form-control' />
                                        </div>
                                        <div className='col-md-2 mb-3'>
                                            <label className='form-label'>Booking To</label>
                                            <input name="BookingDateTo" value={filters.BookingDateTo} onChange={handleChange} type='date' className='form-control' />
                                        </div>
                                        <div className='col-md-2 mb-3'>
                                            <label className='form-label'>Checkin</label>
                                            <input name="CheckInDateFrom" value={filters.CheckInDateFrom} onChange={handleChange} type='date' className='form-control' />
                                        </div>
                                        <div className='col-md-2 mb-3'>
                                            <label className='form-label'>Check Out</label>
                                            <input name="CheckInDateTo" value={filters.CheckInDateTo} onChange={handleChange} type='date' className='form-control' />
                                        </div>

                                        <div className='col-md-4 d-flex align-items-end mb-3'>
                                            <button type="submit" className='btn btn-primary me-2'>{loading ? 'Filtering...' : 'Filter'}</button>
                                            <button type="button" onClick={clearFilters} className='btn btn-danger me-2'>Clear</button>
                                            <button
                                                type="button"
                                                className='btn btn-info'
                                                onClick={() => setShowMore(!showMore)}
                                            >
                                                {showMore ? "Hide Filters" : "Show More Filters"}
                                            </button>
                                        </div>


                                        
                                        <div
                                            className='w-100'
                                            style={{
                                                maxHeight: showMore ? "2000px" : "0px",
                                                overflow: "hidden",
                                                transition: "max-height 0.7s ease-in-out",
                                            }}
                                        >
                                            <div className='row mt-3'>

                                                <div className='col-md-3 mb-3'>
                                                    <label className='form-label'>Agent Name</label>
                                                    <select className='form-control form-select' name="AgentName" value={filters.AgentName} onChange={handleChange}>
                                                        <option>Select Agent</option>
                                                        {agentList.map(agent => (
                                                            <option key={agent.AgentID} value={agent.AgentID}>
                                                                {agent.TA_Name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className='col-md-3 mb-3'>
                                                    <label className='form-label'>Company Name</label>
                                                    <select className='form-control form-select' name="CompName" value={filters.CompName} onChange={handleChange}>
                                                        <option value="">Select Corporate</option>
                                                        {corporateList.map((corp) => (
                                                            <option key={corp.CorporateID} value={corp.CorporateID}>
                                                                {corp.TA_Name} (CP_{corp.CorporateCode || "N/A"})
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className='col-md-3 mb-3'>
                                                    <label className='form-label'>Market Segment</label>
                                                    <Select
                                                        isMulti
                                                        name="MarketSegment"
                                                        value={marketSegments
                                                            .filter(option => filters.MarketSegment.includes(option.Code))
                                                            .map(item => ({ value: item.Code, label: item.MarketSeg }))
                                                        }
                                                        onChange={(selected) => {
                                                            handleChange({
                                                                target: {
                                                                    name: "MarketSegment",
                                                                    value: selected ? selected.map((s) => s.value) : []
                                                                }
                                                            });
                                                        }}
                                                        options={marketSegments.map(item => ({
                                                            value: item.Code,
                                                            label: item.MarketSeg
                                                        }))}
                                                    />
                                                </div>
                                                <div className='col-md-3 mb-3'>
                                                    <label className='form-label'>Business Source</label>
                                                    <Select
                                                        isMulti
                                                        name="BusinessSource"
                                                        value={businessSources
                                                            .filter(option => filters.BusinessSource.includes(option.Code))
                                                            .map(item => ({ value: item.Code, label: item.BusinessSource }))
                                                        }
                                                        onChange={(selected) => {
                                                            handleChange({
                                                                target: {
                                                                    name: "BusinessSource",
                                                                    value: selected ? selected.map((s) => s.value) : []
                                                                }
                                                            });
                                                        }}
                                                        options={businessSources.map(item => ({
                                                            value: item.Code,
                                                            label: item.BusinessSource
                                                        }))}
                                                    />
                                                </div>
                                                <div className='col-md-3 mb-3'>
                                                    <label className='form-label'>Guest Name</label>
                                                    <input name="GuestName" value={filters.GuestName} onChange={handleChange} type='text' className='form-control' />
                                                </div>
                                                <div className='col-md-2 mb-3'>
                                                    <label className='form-label'>Booking Status</label>
                                                    <select name="BookingStatus" value={filters.BookingStatus} onChange={handleChange} className='form-control form-select'>
                                                        <option value=''>Select</option>
                                                        <option value='Pending'>Pending</option>
                                                        <option value='Confirmed'>Confirmed</option>
                                                        <option value='Cancelled'>Cancelled</option>
                                                    </select>
                                                </div>
                                                <div className='col-md-2 mb-3'>
                                                    <label className='form-label'>Payment Status</label>
                                                    <select name="PaymentStatus" value={filters.PaymentStatus} onChange={handleChange} className='form-control form-select'>
                                                        <option value=''>Select</option>
                                                        <option value='Pending'>Pending</option>
                                                        <option value='Paid'>Paid</option>
                                                        <option value='hold'>Hold</option>
                                                    </select>
                                                </div>
                                                <div className='col-md-3 mb-3'>
                                                    <label className='form-label'>Confirmation Code</label>
                                                    <input name="ConfirmationNumber" value={filters.ConfirmationNumber} onChange={handleChange} type='text' className='form-control' />
                                                </div>
                                                <div className='col-md-2 mb-3'>
                                                    <label className='form-label'>BON Ref No</label>
                                                    <input name="BONRefNumber" value={filters.BONRefNumber} onChange={handleChange} type='text' className='form-control' />
                                                </div>

                                            

                                            </div>

                                        </div>


                                    </form> */}

                                    {/* <div className="card">
                                        <div className="card-body">
                                            <div className="row">
                                              
                                                <div className="col-md-2">
                                                    <label>Booking From</label>
                                                    <input
                                                        name="BookingDateFrom"
                                                        value={filters.BookingDateFrom}
                                                        onChange={handleChange}
                                                        type="date"
                                                        className="form-control"
                                                    />
                                                </div>
                                                <div className="col-md-2">
                                                    <label>Booking To</label>
                                                    <input
                                                        name="BookingDateTo"
                                                        value={filters.BookingDateTo}
                                                        onChange={handleChange}
                                                        type="date"
                                                        className="form-control"
                                                    />
                                                </div>
                                                <div className="col-md-2">
                                                    <label>Check In</label>
                                                    <input
                                                        name="CheckInDateFrom"
                                                        value={filters.CheckInDateFrom}
                                                        onChange={handleChange}
                                                        type="date"
                                                        className="form-control"
                                                    />
                                                </div>
                                                <div className="col-md-2">
                                                    <label>Check Out</label>
                                                    <input
                                                        name="CheckInDateTo"
                                                        value={filters.CheckInDateTo}
                                                        onChange={handleChange}
                                                        type="date"
                                                        className="form-control"
                                                    />
                                                </div>

                                                <div className='col-md-3 justy-content-center'>
                                                    <button
                                                        className="btn "
                                                        style={{
                                                            fontSize: "12px",
                                                            marginTop: "21px",
                                                            textDecoration: "underline",
                                                            color: "#1572e8"
                                                        }}
                                                        onClick={() => setAdvanced(prev => !prev)}
                                                        aria-expanded={advanced}
                                                    >
                                                        {advanced ? "Go to Basic Search" : "Go to Advance Search"}
                                                    </button>
                                                </div>

                                     
                                                <div className={`w-100 advanced-wrap ${advanced ? "open" : ""}`}>
                                                    <div className="advanced-inner">
                                                        <div className="row mt-3">
                                                            <div className="col-md-3 mb-3">
                                                                <label>Agent Name</label>
                                                                <select
                                                                    className="form-control form-select"
                                                                    name="AgentName"
                                                                    value={filters.AgentName}
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="">Select Agent</option>
                                                                    {agentList.map(agent => (
                                                                        <option key={agent.AgentID} value={agent.AgentID}>
                                                                            {agent.TA_Name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                            <div className="col-md-3 mb-3">
                                                                <label>Company Name</label>
                                                                <select
                                                                    className="form-control form-select"
                                                                    name="CompName"
                                                                    value={filters.CompName}
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="">Select Corporate</option>
                                                                    {corporateList.map((corp) => (
                                                                        <option key={corp.CorporateID} value={corp.CorporateID}>
                                                                            {corp.TA_Name} (CP_{corp.CorporateCode || "N/A"})
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                            <div className="col-md-3 mb-3">
                                                                <label>Market Segment</label>
                                                                <Select
                                                                    isMulti
                                                                    name="MarketSegment"
                                                                    value={marketSegments
                                                                        .filter(option => filters.MarketSegment?.includes(option.Code))
                                                                        .map(item => ({ value: item.Code, label: item.MarketSeg }))}
                                                                    onChange={(selected) => {
                                                                        handleChange({
                                                                            target: {
                                                                                name: "MarketSegment",
                                                                                value: selected ? selected.map((s) => s.value) : []
                                                                            }
                                                                        });
                                                                    }}
                                                                    options={marketSegments.map(item => ({
                                                                        value: item.Code,
                                                                        label: item.MarketSeg
                                                                    }))}
                                                                />
                                                            </div>

                                                            <div className="col-md-3 mb-3">
                                                                <label>Business Source</label>
                                                                <Select
                                                                    isMulti
                                                                    name="BusinessSource"
                                                                    value={businessSources
                                                                        .filter(option => filters.BusinessSource?.includes(option.Code))
                                                                        .map(item => ({ value: item.Code, label: item.BusinessSource }))}
                                                                    onChange={(selected) => {
                                                                        handleChange({
                                                                            target: {
                                                                                name: "BusinessSource",
                                                                                value: selected ? selected.map((s) => s.value) : []
                                                                            }
                                                                        });
                                                                    }}
                                                                    options={businessSources.map(item => ({
                                                                        value: item.Code,
                                                                        label: item.BusinessSource
                                                                    }))}
                                                                />
                                                            </div>

                                                            <div className="col-md-3 mb-3">
                                                                <label>Guest Name</label>
                                                                <input
                                                                    name="GuestName"
                                                                    value={filters.GuestName}
                                                                    onChange={handleChange}
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter Name"
                                                                />
                                                            </div>

                                                            <div className="col-md-2 mb-3">
                                                                <label>Booking Status</label>
                                                                <select
                                                                    name="BookingStatus"
                                                                    value={filters.BookingStatus}
                                                                    onChange={handleChange}
                                                                    className="form-control form-select"
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="Pending">Pending</option>
                                                                    <option value="Confirmed">Confirmed</option>
                                                                    <option value="Cancelled">Cancelled</option>
                                                                </select>
                                                            </div>

                                                            <div className="col-md-2 mb-3">
                                                                <label>Payment Status</label>
                                                                <select
                                                                    name="PaymentStatus"
                                                                    value={filters.PaymentStatus}
                                                                    onChange={handleChange}
                                                                    className="form-control form-select"
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="Pending">Pending</option>
                                                                    <option value="Paid">Paid</option>
                                                                    <option value="hold">Hold</option>
                                                                </select>
                                                            </div>

                                                            <div className="col-md-3 mb-3">
                                                                <label>Confirmation Code</label>
                                                                <input
                                                                    name="ConfirmationNumber"
                                                                    value={filters.ConfirmationNumber}
                                                                    onChange={handleChange}
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter Code"
                                                                />
                                                            </div>

                                                            <div className="col-md-2 mb-3">
                                                                <label>BON Ref No</label>
                                                                <input
                                                                    name="BONRefNumber"
                                                                    value={filters.BONRefNumber}
                                                                    onChange={handleChange}
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter No"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </div>

                                        <div className="card-footer">
                                            <div className="text-end">
                                                <button type="button" className="btn btn-danger btn-sm me-2" onClick={clearFilters}>
                                                    Reset
                                                </button>
                                                <button type="button" className="btn btn-primary btn-sm " onClick={handleFilter}>
                                                    Search
                                                </button>

                                            </div>
                                        </div>
                                    </div> */}

                                    <div className="card">
                                        <div className="card-body">
                                            <div className="">
                                                <div className='d-flex' style={{ gap: "55px" }}>
                                                    <div >
                                                        <label>Booking From</label>
                                                        <input
                                                            style={{ width: "170px" }}
                                                            name="BookingDateFrom"
                                                            value={filters.BookingDateFrom}
                                                            onChange={handleChange}
                                                            type="date"
                                                            className="form-control"
                                                        />
                                                    </div>
                                                    <div >
                                                        <label>Booking To</label>
                                                        <input
                                                            style={{ width: "165px" }}
                                                            name="BookingDateTo"
                                                            value={filters.BookingDateTo}
                                                            onChange={handleChange}
                                                            type="date"
                                                            className="form-control"
                                                        />
                                                    </div>
                                                    <div >
                                                        <label>Check In</label>
                                                        <input
                                                            style={{ width: "169px" }}
                                                            name="CheckInDateFrom"
                                                            value={filters.CheckInDateFrom}
                                                            onChange={handleChange}
                                                            type="date"
                                                            className="form-control"
                                                        />
                                                    </div>
                                                    <div >
                                                        <label>Check Out</label>
                                                        <input
                                                            style={{ width: "173px" }}
                                                            name="CheckInDateTo"
                                                            value={filters.CheckInDateTo}
                                                            onChange={handleChange}
                                                            type="date"
                                                            className="form-control"
                                                        />
                                                    </div>

                                                    <div className=' justy-content-center'>
                                                        <button
                                                            className="btn "
                                                            style={{
                                                                fontSize: "12px",
                                                                marginTop: "21px",
                                                                textDecoration: "underline",
                                                                color: "#1572e8"
                                                            }}
                                                            onClick={() => setAdvanced(prev => !prev)}
                                                            aria-expanded={advanced}
                                                        >
                                                            {advanced ? "Go to Basic Search" : "Go to Advance Search"}
                                                        </button>
                                                    </div>
                                                </div>

                                                {/* Advanced fields wrapped for slide */}
                                                <div className={`w-100 advanced-wrap ${advanced ? "open" : ""}`}>
                                                    <div className="advanced-inner">
                                                        <div className=" mt-3">
                                                            <div className='d-flex' style={{ gap: "56px" }}>
                                                                <div className=" mb-3">
                                                                    <label>Agent Name</label>
                                                                    <select
                                                                        style={{ width: "169px" }}
                                                                        className="form-control form-select"
                                                                        name="AgentName"
                                                                        value={filters.AgentName}
                                                                        onChange={handleChange}
                                                                    >
                                                                        <option value="">Select Agent</option>
                                                                        {agentList.map(agent => (
                                                                            <option key={agent.AgentID} value={agent.AgentID}>
                                                                                {agent.TA_Name}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>

                                                                <div className=" mb-3">
                                                                    <label>Company Name</label>
                                                                    <select
                                                                        style={{ width: "164px" }}
                                                                        className="form-control form-select"
                                                                        name="CompName"
                                                                        value={filters.CompName}
                                                                        onChange={handleChange}
                                                                    >
                                                                        <option value="">Select Corporate</option>
                                                                        {corporateList.map((corp) => (
                                                                            <option key={corp.CorporateID} value={corp.CorporateID}>
                                                                                {corp.TA_Name} (CP_{corp.CorporateCode || "N/A"})
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>

                                                                <div className=" mb-3">
                                                                    <label>Market Segment</label>
                                                                    <Select
                                                                        isMulti
                                                                        name="MarketSegment"
                                                                        styles={{
                                                                            container: (base) => ({
                                                                                ...base,
                                                                                width: "170px"
                                                                            })
                                                                        }}
                                                                        value={marketSegments
                                                                            .filter(option => filters.MarketSegment?.includes(option.Code))
                                                                            .map(item => ({ value: item.Code, label: item.MarketSeg }))}
                                                                        onChange={(selected) => {
                                                                            handleChange({
                                                                                target: {
                                                                                    name: "MarketSegment",
                                                                                    value: selected ? selected.map((s) => s.value) : []
                                                                                }
                                                                            });
                                                                        }}
                                                                        options={marketSegments.map(item => ({
                                                                            value: item.Code,
                                                                            label: item.MarketSeg
                                                                        }))}
                                                                    />
                                                                </div>

                                                                <div className=" mb-3">
                                                                    <label>Business Source</label>
                                                                    <Select

                                                                        isMulti
                                                                        name="BusinessSource"
                                                                        styles={{
                                                                            container: (base) => ({
                                                                                ...base,
                                                                                width: "170px"
                                                                            })
                                                                        }}
                                                                        value={businessSources
                                                                            .filter(option => filters.BusinessSource?.includes(option.Code))
                                                                            .map(item => ({ value: item.Code, label: item.BusinessSource }))}
                                                                        onChange={(selected) => {
                                                                            handleChange({
                                                                                target: {
                                                                                    name: "BusinessSource",
                                                                                    value: selected ? selected.map((s) => s.value) : []
                                                                                }
                                                                            });
                                                                        }}
                                                                        options={businessSources.map(item => ({
                                                                            value: item.Code,
                                                                            label: item.BusinessSource
                                                                        }))}
                                                                    />
                                                                </div>

                                                                <div className=" mb-3">
                                                                    <label>Guest Name</label>
                                                                    <input
                                                                        name="GuestName"
                                                                        value={filters.GuestName}
                                                                        onChange={handleChange}
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Enter Name"
                                                                    />
                                                                </div>

                                                            </div>

                                                            <div className='d-flex' style={{ gap: "55px" }}>
                                                                <div className=" mb-3">
                                                                    <label>Booking Status</label>
                                                                    <select
                                                                        style={{ width: "170px" }}
                                                                        name="BookingStatus"
                                                                        value={filters.BookingStatus}
                                                                        onChange={handleChange}
                                                                        className="form-control form-select"
                                                                    >
                                                                        <option value="">Select</option>
                                                                        <option value="Pending">Pending</option>
                                                                        <option value="Confirmed">Confirmed</option>
                                                                        <option value="Cancelled">Cancelled</option>
                                                                    </select>
                                                                </div>

                                                                <div className=" mb-3">
                                                                    <label>Payment Status</label>
                                                                    <select
                                                                        style={{ width: "165px" }}
                                                                        name="PaymentStatus"
                                                                        value={filters.PaymentStatus}
                                                                        onChange={handleChange}
                                                                        className="form-control form-select"
                                                                    >
                                                                        <option value="">Select</option>
                                                                        <option value="Pending">Pending</option>
                                                                        <option value="Paid">Paid</option>
                                                                        <option value="hold">Hold</option>
                                                                    </select>
                                                                </div>

                                                                <div className=" mb-3">
                                                                    <label>Confirmation Code</label>
                                                                    <input
                                                                        style={{ width: "170px" }}
                                                                        name="ConfirmationNumber"
                                                                        value={filters.ConfirmationNumber}
                                                                        onChange={handleChange}
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Enter Code"
                                                                    />
                                                                </div>

                                                                <div className=" mb-3">
                                                                    <label>BON Ref No</label>
                                                                    <input
                                                                        style={{ width: "172px" }}
                                                                        name="BONRefNumber"
                                                                        value={filters.BONRefNumber}
                                                                        onChange={handleChange}
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Enter No"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* end advanced-wrap */}
                                            </div>
                                        </div>

                                        <div className="card-footer">
                                            <div className="text-end">
                                                <button type="button" className="btn btn-danger btn-sm me-2" onClick={clearFilters}>
                                                    Reset
                                                </button>
                                                <button type="button" className="btn btn-primary btn-sm " onClick={handleFilter}>
                                                    Search
                                                </button>

                                            </div>
                                        </div>
                                    </div>



                                    <div className='card'>
                                        <div className='card-header'>
                                            <div className='d-flex justify-content-between align-item-center'>
                                                <h5 className='card-title'>Booking Report</h5>
                                                <div>
                                                    <button className='btn btn-sm btn-primary me-2' onClick={handleExport}>Export</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='card-body'>
                                            <div className="table-responsive">
                                                <table className="display table  table-bordered table-striped table-hover basic-datatables">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: "38px" }}>#</th>
                                                            <th style={{ width: "110px" }} >BON REF. Id</th>
                                                            <th style={{ width: "87px" }}>Conf. No</th>
                                                            <th style={{ width: "84px" }}>Arr</th>
                                                            <th style={{ width: "84px" }}>Dep</th>
                                                            <th>Comp Name</th>
                                                            <th>Prop Name</th>
                                                            <th>Guest Info</th>
                                                            <th>Adl</th>
                                                            <th>Chl</th>
                                                            <th>Totl Rms</th>
                                                            <th style={{ width: "81px" }}>Payment </th>
                                                            <th style={{ width: "81px" }}>Status</th>
                                                            <th style={{ width: "95px" }}>Book On</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {loading && (
                                                            <tr>
                                                                <td colSpan={14} className="text-center">Loading...</td>
                                                            </tr>
                                                        )}

                                                        {!loading && bookingData && bookingData.length === 0 && (
                                                            <tr>
                                                                <td colSpan={14} className="text-center">No records found</td>
                                                            </tr>
                                                        )}

                                                        {!loading && bookingData && bookingData.map((row, idx) => (
                                                            <tr key={idx}>
                                                                <td>{row.SrNo ?? idx + 1}</td>
                                                                <td>{row.BONRESID ?? ''}</td>
                                                                <td>{row.PMSRESID ?? row.ConfirmationNumber ?? ''}</td>
                                                                <td>{row.CheckInDate ?? ''}</td>
                                                                <td>{row.CheckOutDate ?? ''}</td>
                                                                <td>{row.CompanyName ?? '-'}</td>
                                                                <td><div>{row.PropertyName ?? '-'}</div>
                                                                    <div><div style={{ fontSize: 12, color: '#666' }}>{row.RoomCode ?? ''}</div></div></td>
                                                                <td> {row.GuestName}</td>
                                                                <td>{row.Adults ?? 0}</td>
                                                                <td>{row.Child ?? 0}</td>
                                                                <td>{row.TotalRoom ?? 0}</td>
                                                                <td>{typeof row.TotalPayment !== 'undefined' ? row.TotalPayment : '-'}</td>
                                                                <td>{row.BookingStatus ?? '-'}</td>
                                                                <td>{row.BookingDate ?? ''}</td>
                                                            </tr>
                                                        ))}

                                                    </tbody>

                                                </table>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
